import React, { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Grid,
  Button,
  Paper,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Divider
} from "@mui/material";
import { PostData, PostFormData } from "../../api/service";

export default function NSSRegistrationForm() {

  const [formData, setFormData] = useState({
    roll: '',
    samarth: '',
    programme: '',
    department: '',
    studentName: '',
    year_semester: '',
    photo: null,
    dob: '',
    email: '',
    contact: '',
    whatsapp: '',
    gender: '',
    father: '',
    fatherContact: '',
    mother: '',
    motherContact: '',
    guardian: '',
    guardianRelation: '',
    guardianContact: '',
    blood: '',
    medical: '',
    state: '',
    income: '',
    permanentAddress: '',
    presentAddress: '',
    district: '',
    pincode: '',
    language: '',
    religion: '',
    category: '',
    categoryCert: null,
    minority: '',
    bpl: '',
    ews: '',
    pwd: '',
    disability: '',
    pan: '',
    panCard: null,
    aadhaar: '',
    aadhaarCard: null,
    apaar: '',
    apaarId: null,
    account: '',
    bank: '',
    holder: '',
    ifsc: '',
    branch: '',
    passbook: null,
    tenth: '',
    twelfth: '',
    twelfthStream: '',
    scholarship: '',
    career: '',
    hobbies: '',
    computer: '',
    bharatId: '',
    declaration_accepted: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'file') {
      setFormData({ ...formData, [name]: files[0] });
    } else if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const section = (title) => (
    <Grid item xs={12}>
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 3 }}>
        {title}
      </Typography>
      <Divider />
    </Grid>
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.declaration_accepted) {
      alert("Please accept declaration");
      return;
    }

    // File validation
    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxSize = 2 * 1024 * 1024; // 2MB
    const filesToCheck = ['photo', 'categoryCert', 'panCard', 'aadhaarCard', 'apaarId', 'passbook'];

    for (let key of filesToCheck) {
      const file = formData[key];
      if (file) {
        if (!allowedTypes.includes(file.type)) {
          alert(`Invalid file type for ${key}. Only JPG, PNG, PDF allowed.`);
          return;
        }
        if (file.size > maxSize) {
          alert(`File ${key} is too large. Max 2MB allowed.`);
          return;
        }
      }
    }

    console.log(formData);
    const formDataObj = new FormData();
    formDataObj.append('student_name', formData.studentName);
    formDataObj.append('father_name', formData.father);
    formDataObj.append('mother_name', formData.mother);
    formDataObj.append('gender', formData.gender);
    formDataObj.append('dob', formData.dob);
    formDataObj.append('mobile', formData.contact);
    formDataObj.append('email', formData.email);
    formDataObj.append('college_school_name', 'Dispur College');
    formDataObj.append('course', formData.programme);
    formDataObj.append('year_semester', formData.year_semester);
    formDataObj.append('roll_no', formData.roll);
    formDataObj.append('address', formData.permanentAddress);
    formDataObj.append('district', formData.district);
    formDataObj.append('pin_code', formData.pincode);
    if (formData.photo) formDataObj.append('photo', formData.photo);
    formDataObj.append('declaration_accepted', formData.declaration_accepted ? 1 : 0);
    formDataObj.append('registration_date', new Date().toISOString().split('T')[0]);
    formDataObj.append('time_stamp', new Date().toISOString());
    formDataObj.append('samarth', formData.samarth);
    formDataObj.append('department', formData.department);
    formDataObj.append('whatsapp', formData.whatsapp);
    formDataObj.append('father_contact', formData.fatherContact);
    formDataObj.append('mother_contact', formData.motherContact);
    formDataObj.append('guardian', formData.guardian);
    formDataObj.append('guardian_relation', formData.guardianRelation);
    formDataObj.append('guardian_contact', formData.guardianContact);
    formDataObj.append('blood_group', formData.blood);
    formDataObj.append('medical_condition', formData.medical);
    formDataObj.append('state', formData.state);
    formDataObj.append('family_income', formData.income);
    formDataObj.append('present_address', formData.presentAddress);
    formDataObj.append('first_language', formData.language);
    formDataObj.append('religion', formData.religion);
    formDataObj.append('category', formData.category);
    if (formData.categoryCert) formDataObj.append('category_certificate', formData.categoryCert);
    formDataObj.append('minority', formData.minority);
    formDataObj.append('bpl_category', formData.bpl);
    formDataObj.append('ews', formData.ews);
    formDataObj.append('pwd', formData.pwd);
    formDataObj.append('disability', formData.disability);
    formDataObj.append('pan_number', formData.pan);
    if (formData.panCard) formDataObj.append('pan_card', formData.panCard);
    formDataObj.append('aadhaar_number', formData.aadhaar);
    if (formData.aadhaarCard) formDataObj.append('aadhaar_card', formData.aadhaarCard);
    formDataObj.append('apaar_id', formData.apaar);
    if (formData.apaarId) formDataObj.append('apaar_id_file', formData.apaarId);
    formDataObj.append('bank_account', formData.account);
    formDataObj.append('bank_name', formData.bank);
    formDataObj.append('account_holder', formData.holder);
    formDataObj.append('ifsc_code', formData.ifsc);
    formDataObj.append('bank_branch', formData.branch);
    if (formData.passbook) formDataObj.append('passbook', formData.passbook);
    formDataObj.append('tenth_percentage', formData.tenth);
    formDataObj.append('twelfth_percentage', formData.twelfth);
    formDataObj.append('twelfth_stream', formData.twelfthStream);
    formDataObj.append('scholarship_details', formData.scholarship);
    formDataObj.append('perceived_career', formData.career);
    formDataObj.append('hobbies_skills', formData.hobbies);
    formDataObj.append('computer_knowledge', formData.computer);
    formDataObj.append('bharat_id', formData.bharatId);
    PostFormData(`/nss/register`, formDataObj)
    .then((resp) => {
      alert("Form Submitted");
    })
   
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" align="center" gutterBottom>
          NSS Registration Form – Dispur College
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>

            {section("Academic Details")}

            <Grid item xs={12} md={3}><TextField fullWidth label="College Roll Number" name="roll" value={formData.roll} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={3}><TextField fullWidth label="Samarth Form Number" name="samarth" value={formData.samarth} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={3}><TextField fullWidth label="Programme of Study" name="programme" value={formData.programme} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={3}><TextField fullWidth label="Department / Stream" name="department" value={formData.department} onChange={handleChange} /></Grid>
               <Grid item xs={12} md={3}><TextField fullWidth label="Semester / Year" name="year_semester" value={formData.year_semester} onChange={handleChange} /></Grid>


            {section("Personal Details")}

            <Grid item xs={12} md={4}><TextField fullWidth label="Student Name" name="studentName" value={formData.studentName} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField label="Photo" InputLabelProps={{shrink: true}} type="file" fullWidth name="photo" onChange={handleChange} /><Typography variant="caption" color="textSecondary">Only JPG, PNG, PDF files allowed. Max 2MB per file.</Typography></Grid>
            
            <Grid item xs={12} md={4}><TextField type="date" fullWidth InputLabelProps={{ shrink: true }} label="Date of Birth" name="dob" value={formData.dob} onChange={handleChange} /></Grid>

            <Grid item xs={12} md={4}><TextField fullWidth label="Email ID" name="email" value={formData.email} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="Contact Number" name="contact" value={formData.contact} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="WhatsApp Number" name="whatsapp" value={formData.whatsapp} onChange={handleChange} /></Grid>

            <Grid item xs={12} md={4}>
              <TextField select fullWidth label="Gender" name="gender" value={formData.gender} onChange={handleChange}>
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextField>
            </Grid>


            {section("Family Details")}

            <Grid item xs={12} md={4}><TextField fullWidth label="Father Name" name="father" value={formData.father} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="Father Contact Number" name="fatherContact" value={formData.fatherContact} onChange={handleChange} /></Grid>

            <Grid item xs={12} md={4}><TextField fullWidth label="Mother Name" name="mother" value={formData.mother} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="Mother Contact Number" name="motherContact" value={formData.motherContact} onChange={handleChange} /></Grid>

            <Grid item xs={12} md={4}><TextField fullWidth label="Local Guardian Name" name="guardian" value={formData.guardian} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="Relationship with Local Guardian" name="guardianRelation" value={formData.guardianRelation} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="Guardian Contact Number" name="guardianContact" value={formData.guardianContact} onChange={handleChange} /></Grid>


            {section("Health & Social Details")}

            <Grid item xs={12} md={3}><TextField fullWidth label="Blood Group" name="blood" value={formData.blood} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={9}><TextField fullWidth label="Medical Condition (If No write 'No')" name="medical" value={formData.medical} onChange={handleChange} /></Grid>

            <Grid item xs={12} md={4}><TextField fullWidth label="State of Permanent Residence" name="state" value={formData.state} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="Family Annual Income" name="income" value={formData.income} onChange={handleChange} /></Grid>

            <Grid item xs={12} md={6}><TextField fullWidth multiline rows={2} label="Permanent Address with PIN" name="permanentAddress" value={formData.permanentAddress} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth multiline rows={2} label="Present Address with PIN" name="presentAddress" value={formData.presentAddress} onChange={handleChange} /></Grid>
<Grid item xs={12} md={4}><TextField fullWidth label="District" name="district" value={formData.district} onChange={handleChange} /></Grid>

<Grid item xs={12} md={4}><TextField fullWidth label="Pincode" name="pincode" value={formData.pincode} onChange={handleChange} /></Grid>


            <Grid item xs={12} md={3}><TextField fullWidth label="First Language / Community" name="language" value={formData.language} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={3}><TextField fullWidth label="Religion" name="religion" value={formData.religion} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={3}><TextField fullWidth label="Category" name="category" value={formData.category} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={3}><TextField type="file" InputLabelProps={{shrink: true}} fullWidth label="Category Certificate" name="categoryCert" onChange={handleChange} /><Typography variant="caption" color="textSecondary">Only JPG, PNG, PDF files allowed. Max 2MB per file.</Typography></Grid>
           

            <Grid item xs={12} md={3}><TextField select fullWidth label="Minority" name="minority" value={formData.minority} onChange={handleChange}><MenuItem value="Yes">Yes</MenuItem><MenuItem value="No">No</MenuItem></TextField></Grid>
            <Grid item xs={12} md={3}><TextField select fullWidth label="BPL Category" name="bpl" value={formData.bpl} onChange={handleChange}><MenuItem value="Yes">Yes</MenuItem><MenuItem value="No">No</MenuItem></TextField></Grid>
            <Grid item xs={12} md={3}><TextField select fullWidth label="EWS" name="ews" value={formData.ews} onChange={handleChange}><MenuItem value="Yes">Yes</MenuItem><MenuItem value="No">No</MenuItem></TextField></Grid>
            <Grid item xs={12} md={3}><TextField select fullWidth label="PwD" name="pwd" value={formData.pwd} onChange={handleChange}><MenuItem value="Yes">Yes</MenuItem><MenuItem value="No">No</MenuItem></TextField></Grid>

            <Grid item xs={12}><TextField fullWidth label="If PwD specify Disability" name="disability" value={formData.disability} onChange={handleChange} /></Grid>


            {section("Identity Documents & Bank Details")}

            <Grid item xs={12} md={4}><TextField fullWidth label="PAN Number" name="pan" value={formData.pan} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField type="file" InputLabelProps={{shrink: true}} fullWidth label="Upload PAN Card" name="panCard" onChange={handleChange} /><Typography variant="caption" color="textSecondary">Only JPG, PNG, PDF files allowed. Max 2MB per file.</Typography></Grid>
        

            <Grid item xs={12} md={4}><TextField fullWidth label="AADHAAR Number" name="aadhaar" value={formData.aadhaar} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField type="file"  InputLabelProps={{shrink: true}} fullWidth label="Upload AADHAAR Card" name="aadhaarCard" onChange={handleChange} /><Typography variant="caption" color="textSecondary">Only JPG, PNG, PDF files allowed. Max 2MB per file.</Typography></Grid>
        

            <Grid item xs={12} md={4}><TextField fullWidth label="APAAR ID Number" name="apaar" value={formData.apaar} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField type="file"  InputLabelProps={{shrink: true}} fullWidth label="Upload APAAR ID" name="apaarId" onChange={handleChange} /><Typography variant="caption" color="textSecondary">Only JPG, PNG, PDF files allowed. Max 2MB per file.</Typography></Grid>
         

            <Grid item xs={12} md={4}><TextField fullWidth label="Bank Account Number" name="account" value={formData.account} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="Bank Name" name="bank" value={formData.bank} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="Account Holder Name" name="holder" value={formData.holder} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="IFSC Code" name="ifsc" value={formData.ifsc} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="Bank Branch Name" name="branch" value={formData.branch} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField type="file" InputLabelProps={{shrink: true}} fullWidth label="Upload Passbook First Page" name="passbook" onChange={handleChange} /><Typography variant="caption" color="textSecondary">Only JPG, PNG, PDF files allowed. Max 2MB per file.</Typography></Grid>
        


            {section("Educational & Other Details")}

            <Grid item xs={12} md={4}><TextField fullWidth label="10th Percentage" name="tenth" value={formData.tenth} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="12th Percentage (Write To Appear if HS)" name="twelfth" value={formData.twelfth} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth label="12th Stream" name="twelfthStream" value={formData.twelfthStream} onChange={handleChange} /></Grid>

            <Grid item xs={12}><TextField fullWidth multiline rows={3} label="Scholarship Details" name="scholarship" value={formData.scholarship} onChange={handleChange} /></Grid>
            <Grid item xs={12}><TextField fullWidth multiline rows={2} label="Perceived Career" name="career" value={formData.career} onChange={handleChange} /></Grid>
            <Grid item xs={12}><TextField fullWidth multiline rows={2} label="Hobbies / Skills" name="hobbies" value={formData.hobbies} onChange={handleChange} /></Grid>

            <Grid item xs={12} md={6}><TextField fullWidth label="Knowledge of Computer" name="computer" value={formData.computer} onChange={handleChange} /></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label="My Bharat ID" name="bharatId" value={formData.bharatId} onChange={handleChange} /></Grid>


            <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox name="declaration_accepted" checked={formData.declaration_accepted} onChange={handleChange} />}
                label="I hereby declare that the information provided is true and I agree to follow NSS rules and regulations."
              />
            </Grid>

            <Grid item xs={12}>
              <Button type="submit" variant="contained" size="large" fullWidth>
                Submit Registration
              </Button>
            </Grid>

          </Grid>
        </form>
      </Paper>
    </Container>
  );
}


